  <div class="custom-loader" *ngIf="loaderService.loading$ | async" >
      <img src="../../assets/images/footer-logo.png" alt="Loading..." />
  </div>

    <!--  -->